import { styled, css } from '@vebox/etui-system';
import { createElement } from 'react';
import { _ as _objectWithoutProperties } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import { H5 } from '../H5/H5.js';
import '../Svg-0180d7b5.js';
import Icon from '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import { H4 } from '../H4/H4.js';

const ListItemContentDiv = styled(Div)`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  justify-content: center;
  padding: 0 10px;

  ${props => {
  if (props.isCompact) {
    return css`
        min-height: 48px;
      `;
  }
  return css`
      min-height: 64px;
    `;
}};
`;

const MetaTitleH4 = styled(H4)`
  ${({
  theme
}) => css`
    font-family: ${theme.typography.fontFamily};
    font-size: ${theme.typography.fontSizeBase};
    font-weight: ${theme.typography.fontWeightBold};
    line-height: ${theme.typography.lineHeightBase};
    color: ${theme.palette.text.primary};
  `};

  margin: 0;
`;

const MetaDescriptionH5 = styled(H5)`
  ${({
  theme
}) => css`
    font-family: ${theme.typography.fontFamily};
    font-size: ${theme.typography.fontSizeSmall};
    font-weight: ${theme.typography.fontWeightRegular};
    line-height: ${theme.typography.lineHeightBase};
    color: ${theme.palette.text.primary};
  `};
  margin: 0;
`;

const ListItemMetaDiv = styled(Div)`
  display: flex;
  align-items: flex-start;
  flex: 1;
  text-align: left;
`;

const _excluded = ["icon", "title", "description", "children", "isCompact"];
const ListItemMeta = props => {
  const {
      icon,
      title,
      description,
      children,
      isCompact
    } = props,
    others = _objectWithoutProperties(props, _excluded);
  const content = /*#__PURE__*/createElement(ListItemContentDiv, {
    isCompact: isCompact
  }, title && /*#__PURE__*/createElement(MetaTitleH4, null, title), description && /*#__PURE__*/createElement(MetaDescriptionH5, null, description));
  return /*#__PURE__*/createElement(ListItemMetaDiv, others, icon && /*#__PURE__*/createElement(ListItemContentDiv, {
    isCompact: isCompact
  }, /*#__PURE__*/createElement(Icon, {
    size: 48,
    glyph: icon
  })), (title || description) && content, children);
};

export default ListItemMeta;
